import { Page } from '@betty/navigation';
import QuestsList from '../components/QuestsList';
import { Box } from '@betty/moonlight';

function QuestsPage() {
  return (
    <Page restrictWidth>
      <Box
        width="100%"
        paddingHorizontal={{
          mobile: 'space-400',
          tablet: undefined,
          desktop: undefined,
        }}
      >
        <QuestsList />;
      </Box>
    </Page>
  );
}

export default QuestsPage;
